var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultDuplicatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69595 4.07422L9.20595 10.8922H7.63795L7.14795 4.07422H9.69595ZM7.20395 12.9362C7.20395 12.2642 7.73595 11.7182 8.40795 11.7182C9.07995 11.7182 9.62595 12.2642 9.62595 12.9362C9.62595 13.5942 9.07995 14.1402 8.40795 14.1402C7.73595 14.1402 7.20395 13.5942 7.20395 12.9362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultDuplicatedIcon);
export default __webpack_public_path__ + "static/media/vault-duplicated-icon.dbf620e4ea127a5aad623fdc34c0b2cc.svg";
export { ForwardRef as ReactComponent };